/**
 * 은퇴한 구 문서 유형 키의 표시 명칭 — 결재선 메타 **변경 이력** 화면 전용.
 *
 * ⚠️ 이 맵은 **표시 전용**이다. 선택지(카드 목록)는 Composer 템플릿 목록에서만 파생한다.
 * 그래도 이 맵은 지우지 않는다 — 변경 이력(`HistoryModal`)은 감사 기록이라 구 type 키의 과거 행이
 * 그대로 남아 있고, 지우면 그 자리에서 라벨을 잃고 raw enum(`SAFETY_INSPECTION`)이 새어 나온다.
 * 이력 행의 축 값 `templateKey`가 이 맵에 없으면 현역 템플릿 key다(라운드 4 rename — 결정 #6-A).
 */
export const RETIRED_TYPE_KEY_LABELS: Record<string, string> = {
  SAFETY_INSPECTION: '안전점검 보고서 (SI)',
  DAILY_INSPECTION_LOG: '일일안전점검일지 (DLR)',
  RISK_ASSESSMENT_REPORT: '위험성평가 결과서 (RA)',
  TECHNICAL_GUIDANCE: '기술지도 결과보고서 (TG)',
  TG_NON_COMPLIANCE: '불이행 통보서 (TG-NC)',
  TG_VERIFICATION_REQUEST: '확인요청서 (TG-VR)',
  TG_COMPLETION_CERT: '완료증명서 (TG-CC)',
  TBM: 'TBM',
  TBM_EVIDENCE: 'TBM 증빙',
};
